import React from "react";
import Modal from "react-modal";
import UserInfo from "./UserInfo";
import { IMAGES } from "../config/constants";

const NotificationModal = ({ 
  isOpen, 
  onRequestClose, 
  onClose,
  type, 
  user 
}) => {
  const isSuccess = type === "success";
  
  const modalConfig = {
    success: {
      image: IMAGES.THUMBS_UP,
      title: "Access Granted",
      buttonText: "close"
    },
    error: {
      image: IMAGES.DELETE_DANGER,
      title: "Access Denied",
      buttonText: "Close"
    }
  };

  const config = modalConfig[type] || modalConfig.error;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={`${config.title} Modal`}
      className="edit-success-modal"
      appElement={document.getElementById('root')}
      ariaHideApp={true}
    >
      <div className="modal-content">
        <img
          src={`${process.env.PUBLIC_URL}${config.image}`}
          alt={config.title}
        />
        <h2>{config.title}</h2>
        <UserInfo user={user} />
      </div>
      <button onClick={onClose}>{config.buttonText}</button>
    </Modal>
  );
};

export default NotificationModal;
